import {
  Livewire,
  Alpine,
} from "../../vendor/livewire/livewire/dist/livewire.esm";
import scrollTo from "alpinejs-scroll-to";
import { registerSW } from "virtual:pwa-register";
registerSW();
Alpine.plugin([scrollTo]);
Alpine.data("initTheme", () => ({
  theme: localStorage.getItem("site_theme"),
  defaultTheme:
    localStorage.getItem("site_theme") ||
    (window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"),
  setTheme(val) {
    this.theme = val != "system" ? val : null;
    this.defaultTheme =
      this.theme ||
      (window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light");
    if (this.theme) localStorage.setItem("site_theme", this.theme);
    else localStorage.removeItem("site_theme");
  },
}));
Alpine.data("share", (image, title, text, url) => ({
  setShare() {
    if (navigator.share) {
      // const blob = await fetch(image).then((r) => r.blob());
      // const filesArray = [
      //   new File([blob], "image." + blob.type.split("/")[1], {
      //     type: blob.type,
      //     lastModified: new Date().getTime(),
      //   }),
      // ];
      navigator
        .share({
          // files: filesArray,
          title: title,
          text: text,
          url: url,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    } else console.log("Error sharing");
  },
}));
Alpine.data("stickySidebar", (e, margin = 0) => ({
  init() {
    this.$nextTick(() => {
      $(e).theiaStickySidebar({
        additionalMarginTop: $("header").height() + margin,
      });
    });
  },
}));
Alpine.data("readMore", (e) => ({
  init() {
    $(e).readmore({
      collapsedHeight: 148,
      moreLink:
        '<a href="#" class="justify-center highlight absolute bg-base-100/95 text-sm bottom-0 right-0 flex w-full py-3 text-primary font-semibold">ادامه مطلب</a>',
      lessLink:
        '<a href="#" class="justify-center text-sm text-primary flex w-full py-3 font-semibold">بستن</a>',
    });
  },
}));

Alpine.data("clipboard", (e) => ({
  copyText(text) {
    navigator.clipboard.writeText(text);
    window.dispatchEvent(
      new CustomEvent("notify", { detail: { message: "کپی شد" } })
    );
  },
}));
Alpine.data("notify", (el) => ({
  timeout: null,
  init() {
    this.timeout = setTimeout(() => this.remove(), 4000);
  },
  remove() {
    if (this.timeout) clearTimeout(this.timeout);
    const parent = el.parentElement;
    parent?.classList.add("hidden");
    parent?.classList.remove("flex");
    if (parent) parent.innerHTML = "";
  },
}));
Alpine.data("flipDown", (timeleft) => ({
  init() {
    const clock = $(".flipdown").FlipClock({
      clockFace: "DailyCounter",
      autoStart: true,
      showSeconds: false,
      callbacks: {},
    });
    clock.setTime(timeleft);
    clock.setCountdown(true);
  },
}));
Livewire.start();

let attrs = [
  "snapshot",
  "effects",
  // 'id'
];

function snapKill() {
  document.querySelectorAll("div").forEach(function (element) {
    for (let i in attrs) {
      if (element.getAttribute(`wire:${attrs[i]}`) !== null) {
        element.removeAttribute(`wire:${attrs[i]}`);
      }
    }
  });
}

window.addEventListener("notify", (event) => {
  let timeout = null;
  const toastr = document.querySelector(".toastr");
  toastr.innerHTML = event.detail.message;
  toastr.classList.add("flex");
  toastr.classList.remove("hidden");
  timeout = setTimeout(() => {
    if (timeout) clearTimeout(timeout);
    toastr.classList.add("hidden");
    toastr.classList.remove("flex");
  }, 4000);
});
window.addEventListener("load", (ev) => {
  snapKill();
});
window
  .matchMedia("(prefers-color-scheme: dark)")
  .addEventListener("change", (event) => {
    const theme = localStorage.getItem("theme");
    if (!theme)
      document.documentElement.dataset.theme = event.matches ? "dark" : "light";
  });

document.addEventListener("modal", (e) => {
  document.getElementById(e.detail.id).checked = e.detail.checked;
  window.dispatchEvent(new CustomEvent("hide-loading"));
});
document.addEventListener("open-new-tab", (e) => {
  window.open(e.detail.url, "_blank");
});
